import { render, staticRenderFns } from "./gradeRules.vue?vue&type=template&id=6ecd3be8&scoped=true&"
import script from "./gradeRules.vue?vue&type=script&lang=js&"
export * from "./gradeRules.vue?vue&type=script&lang=js&"
import style0 from "./gradeRules.vue?vue&type=style&index=0&id=6ecd3be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd3be8",
  null
  
)

export default component.exports